import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import RMultilingual from '../Multilingual';
import Input from '~~elements/Input';
import Form from '~~elements/Form';
import { RegistrySectionDiv } from '../../styled';
import { useRegistryState } from '../useRegistry';
import { parseFeeData } from '../service';
import { currencyDisplay } from '../../Const';

const DescriptionTextarea = styled.textarea`
  width: 100%;
  min-height: 200px;
  font-size: 0.9rem;
`;

const FeeSection = ({ onChange, apiInProgress }) => {
  const { registryInfo } = useRegistryState();

  const [currentFeeData, setCurrentFeeData] = useState(parseFeeData(registryInfo));
  const [isFree, setIsFree] = useState(true);

  useEffect(() => {
    setCurrentFeeData(parseFeeData(registryInfo));
  }, [registryInfo]);

  useEffect(() => {
    setIsFree(registryInfo.fee === 0);
  }, [registryInfo.fee]);

  useEffect(() => {
    const originBasicData = JSON.stringify(parseFeeData(registryInfo));
    if (originBasicData === JSON.stringify(currentFeeData)) {
      onChange(null);
      return;
    }

    onChange(currentFeeData);
    return;
  }, [currentFeeData, onChange, registryInfo]);

  const handleInputOnChange = (e) => {
    if (e.target.type === 'checkbox') {
      setCurrentFeeData({
        ...currentFeeData,
        [e.target.name]: e.target.checked,
      });
      return;
    }

    setCurrentFeeData({
      ...currentFeeData,
      [e.target.name]: e.target.value,
    });
  };

  const handleIsFreeOnChange = (e) => {
    if (e.target.checked) {
      setCurrentFeeData({
        ...currentFeeData,
        fee: 0,
      });
    }

    setIsFree(e.target.checked);
  };

  return (
    <RegistrySectionDiv>
      <Form onSubmit={(e) => e.preventDefault()}>
        <div className="box">
          {/* 報名費 */}
          <label>{RMultilingual('FEE.WORDING')}</label>
          <div className="input-field">
            {currencyDisplay[currentFeeData.fee_currency].text}
            <Input
              width="10rem"
              name="fee"
              value={currentFeeData.fee}
              onChange={handleInputOnChange}
              disabled={apiInProgress || isFree}
            />
          </div>
          {/* 免費 */}
          <label>
            {RMultilingual('FEE.FREE')}
            <input type="checkbox" checked={isFree} disabled={apiInProgress} onChange={handleIsFreeOnChange} />
          </label>
          <div className="input-field" />
          {/* 費用、繳費說明 */}
          <label>{RMultilingual('FEE.DESCRIPTION')}</label>
          <div className="input-field">
            <DescriptionTextarea
              name="fee_description"
              value={currentFeeData.fee_description}
              onChange={handleInputOnChange}
              disabled={apiInProgress}
            />
          </div>
        </div>
      </Form>
    </RegistrySectionDiv>
  );
};

export default FeeSection;
